import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { Router } from '@angular/router';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { appointment } from '../../../../icemedx-lib/src/models/schedule/appointment';
import { ScheduleService } from '../../../../icemedx-lib/src/services/schedule/schedule.service';
import { appointmentindex } from '../../../../icemedx-lib/src/models/schedule/appointmentindex';
import { iceColumnDefinition, IcecontrolSettings } from '../../../../icemedx-lib/src/components/models/icesettings';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { day } from '../../../../icemedx-lib/src/models/schedule/day';
import { Validators } from '@angular/forms';
import { calendar } from '../../../../icemedx-lib/src/models/schedule/calendar';
import { slot } from '../../../../icemedx-lib/src/models/schedule/slot';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.scss'],
  providers: [AppService, IceNavService]
})
export class MeetingsComponent extends BaseListView implements OnInit {
  newAppt: appointment = null;
  //private types = [];

  subjectCtrl: IcecontrolSettings = null;
  descCtrl: IcecontrolSettings = null;
  startDateCtrl: IcecontrolSettings = null; 
  startTimeCtrl: IcecontrolSettings = null;

  typeCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "appointment_type", "Select Type")
    .setControlName("appointment_type")
    .createFormControl(IceTypes.appt_type.appttypeInitial, [Validators.required])
    .setOptions(ScheduleService.getAppointmentTypes());

  statusCtrl: IcecontrolSettings = null;
  onlineCtrl: IcecontrolSettings = null;
  locationCtrl: IcecontrolSettings = null;

  constructor(appSvc: AppService,
    loginSvc: LoginService,
    private messageSvc: MessageService,
    navSvc: IceNavService,
    private pyrSvc: PayerService,
    private domSvc: DomainService,
    private schSvc: ScheduleService,
    private medCodeSvc: MedicalcodesService,
    router: Router) {

    super(appSvc, loginSvc, navSvc, router);

    let feaAccess = this.getPermission(userTypes.USER_FEATURES.ufSchedule).default_access;
    this.nameOfView = "Meetings";
    appSvc.defaultMenus();
    appSvc.addBreadcrumb("List of " + this.nameOfView, {}, true, "");

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      setTimeout(function () {
        messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.setInlineEditing(true);
      this.dataViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufSchedule);

      let fromDt = Iceutility.GetDateText(Iceutility.GetLocalDate(), null, false);
      schSvc.getMeetings(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), "", fromDt, "").subscribe(
        data => {
          if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              let eobj: appointmentindex = <appointmentindex>data[0];
              if (eobj == null) continue;
            }
            this.refreshTableData(data);
          }
          else {
            this.refreshTableData([]);
          }
        },
        error => {
          this.refreshTableData([]);
        });
    }

  //  this.medCodeSvc.getCodes("SUBTYPE_ITEM", "", IceTypes.SourceType.srcTypeOfService.toString(), "", "", IceTypes.ACCOUNT_TYPE.actProvider).subscribe(
  //    data => {
  //      if (data != null) {
  //        this.types = data;
  //      }
  //    });
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("time_slot_start", "Start Time", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("appointment_status", "Status", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("appointment_type", "Type", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("subject", "Subject", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("QuickActions", "", false, false),
      new iceColumnDefinition("appointment_key", "appointment_key", true),
    ];
  }

  onGetActionItems(): any[] {
    return [IceTypes.recordQuickActionEdit, IceTypes.recordQuickActionView, IceTypes.recordQuickActionRemove];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    let displayApts = [];
    let duplicateApts = {};

    for (let iapt = 0; iapt < originalData.length; iapt++) {
      let providers = originalData[iapt]["provider_keywords"].split(",");
      originalData[iapt]["providers"] = "";

      /// TODO: refactor this code
      if (duplicateApts[originalData[iapt]["appointment_key"]] != null) {
        for (var iprov = 0; iprov < providers.length; iprov++) {
          var provider = providers[iprov].trim();
          if (provider != "") {
            let cachedProvider = DomainService.mappedProviders[provider.toLowerCase()];

            if (cachedProvider) {
              setTimeout(function () {
                if (displayApts[iapt].providers.indexOf(cachedProvider) === -1) {
                  displayApts[iapt].providers += ", " + cachedProvider;
                }
              }, 200);
            } else {
              this.domSvc.getProviderName(provider)
                .subscribe(data => {
                  if (data && data.length > 0) {
                    if (this.tables[0].iRows.data[iapt]) {
                      if (displayApts[iapt]) {
                        displayApts[iapt].providers += (displayApts[iapt].providers ? ", " : "") + data[0]._providerName;
                      }
                    }
                  }
                });
            }
          }
        }
        continue;
      }

      for (var iprov = 0; iprov < providers.length; iprov++) {
        var provider = providers[iprov].trim();
        if (provider != "") {
          let cachedProvider = DomainService.mappedProviders[provider.toLowerCase()];

          if (cachedProvider) {
            originalData[iapt]["providers"] += (originalData[iapt]["providers"] ? ", " : "") + cachedProvider;
          } else {
            this.domSvc.getProviderName(provider)
              .subscribe(data => {
                if (data && data.length > 0) {
                  if (this.tables[0].iRows.data[iapt]) {
                    if (displayApts[iapt]) {
                      displayApts[iapt].providers += (displayApts[iapt].providers ? ", " : "") + data[0]._providerName;
                    }
                  }
                }
              });
          }
        }
      }

      let iconToUse = "fas fa-walking";
      if (Iceutility.toBoolean(originalData[iapt]["telehealth"])) {
        iconToUse = "fas fa-video";
      }

      if (this.schSvc.appointmentInSession(originalData[iapt]["time_slot_start"], originalData[iapt]["time_slot_end"], originalData[iapt]["appointment_status"]))
        iconToUse += " " + "alert-success";
      else
        iconToUse = "";

      let appttype = 0;
      let foundType = this.typeCtrl.getOptions().filter(t => t.value == Iceutility.toLong(originalData[iapt]["appointment_type"]));
      if (foundType.length > 0) {
        appttype = foundType[0].name;
      }

      let startDateTime = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(originalData[iapt]["time_slot_start"]));
      let dApt = {
        start_time: startDateTime.split(" ")[1],
        appointment_status: ScheduleService.getApptStat(originalData[iapt]["appointment_status"]),
        appointment_type: appttype,
        providers: originalData[iapt]["providers"],
        appointment_key: originalData[iapt]["appointment_key"],
        account_type: originalData[iapt]["account_type"],
        trans_account: originalData[iapt]["trans_account"],
        time_slot_start: startDateTime,
        time_slot_end: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(originalData[iapt]["time_slot_end"])),
        subject: originalData[iapt]["subject"],
        telehealth: originalData[iapt]["telehealth"],
        telehealth_class: iconToUse,
      };
      displayApts.push(dApt);
      duplicateApts[originalData[iapt]["appointment_key"]] = dApt;
    }
    return displayApts;
  }

  onGetEditingControls(): IcecontrolSettings[] {
    /// New Meeting Panel
    this.subjectCtrl = new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "subject", "Enter Meeting Subject")
      .setControlName("subject")
      .createFormControl("", [Validators.required]);

    this.descCtrl = new IcecontrolSettings("icetextarea", { width: "475px" }, null, null, "txt", "Description (Optional)")
      .setControlName("txt")
      .createFormControl("", []);

    let dt = Iceutility.GetLocalDate();
    this.startDateCtrl = new IcecontrolSettings("icedatepicker", { placeholder: "Date", value: dt, timevalue: "" }, null, null, "time_slot_start")
      .setControlName("time_slot_start")
      .createFormControl(dt, [Validators.required]);

    this.startTimeCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "150px" }, null, null, "start_time", "Select Time")
      .setControlName("start_time")
      .createFormControl("", [Validators.required]);

    this.typeCtrl.setOptions(ScheduleService.getAppointmentTypes());

    // Status
    this.statusCtrl = new IcecontrolSettings("iceselect", { menuItems: ScheduleService.getApptStatuses(), width: "475px" }, null, null, "appointment_status", "Select Status")
      .setControlName("appointment_status")
      .createFormControl(IceTypes.appt_status.apptstatComingUp, [Validators.required]);

    this.statusCtrl.setOptions(ScheduleService.getApptStatuses());

    this.onlineCtrl = new IcecontrolSettings("iceslidetoggle", { placeholder: "Video/Audio", onDisplayValue: "Online", offDisplayValue: "Offline", width: "100px" }, null, null, "telehealth", "Location Type")
      .setControlName("telehealth")
      .createFormControl(false, []);

    this.locationCtrl = new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "telehealth_url", "Enter Location or Address")
      .setControlName("telehealth_url")
      .createFormControl("", []);

    // To do Select Staff attendees
    // To do Select Subscriber attendees
    // To do Select Patient attendees
    // To do Select Additional Member attendees

    this.getAppService().setCodeList(this.medCodeSvc, new basecode("SUBTYPE_ITEM"), this.typeCtrl, [IceTypes.SourceType.srcMiscellaneousForms.toString()], false);

    this.schSvc.getCalendar(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), "", Iceutility.ConvertToUTC(dt, false), "").subscribe(
      data => {
        if (data == null) return;
        let slotsToDisplay = [];

        for (let ical = 0; ical < data.length; ical++) {
          let cal: calendar = data[ical];
          if (cal.hasOwnProperty("DAYS")) {
            let days: day[] = cal["DAYS"];
            let start_slot = null, end_slot = null;

            for (let iday = 0; iday < days.length; iday++) {
              let day = days[iday];
              if (day.hasOwnProperty("SLOTS")) {
                let slots = day["SLOTS"];
                for (let slotindex = 0; slotindex < slots.length; slotindex++) {
                  let slt: slot = slots[slotindex];
                  let appointments = slt["APPTS"];

                  if (Iceutility.isdefined(appointments) == false || appointments.length == 0) {
                    slotsToDisplay.push({ value: slt.header, name: slt.header });
                  }
                }
                break; // expect only one day
              }
            }
          }
        }

        let theTime = Iceutility.getDateTextEx(dt).split(" ")[1] + ((dt.getHours() > 12) ? (' PM') : ' AM');
        let foundTime = slotsToDisplay.filter((t) => theTime == t.value);
        if (foundTime.length == 0) slotsToDisplay.push({ value: theTime, name: theTime });

        this.startTimeCtrl.setOptions(slotsToDisplay);
        this.startTimeCtrl.getFormControl().setValue(theTime);
      },
      error => {
        console.log(JSON.stringify(this.schSvc.getLastErrors()));
      });

    return [
      this.subjectCtrl,
      this.descCtrl,
      this.startDateCtrl,
      this.startTimeCtrl,
      this.typeCtrl,
      this.statusCtrl,
      this.onlineCtrl,
      this.locationCtrl
    ];
  }
  isRowSelectionEnabled(): boolean {
    return true;
  }

  /////////////////////////////////////
  // Events
  onButtonClick(event) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        default: {
          // Add New Appt to DB
          let appSvc = this.getAppService();
          if (appSvc.processEditPanelSectionButtons(this.getEditingSectionTag(), event.buttonSettings.id)) {
            if (this.newAppt == null) break;

            // To do fix up time_slot_start, time_slot_end
            let startTime: string = this.startTimeCtrl.getFormControl().value;
            if (startTime.length == 0) {
              this.messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "No start time is selected.");
              return;
            }

            let startDateandTime = Iceutility.GetDateText(this.startDateCtrl.getFormControl().value, null, false) + " " + startTime;

            // set times and duration
            this.newAppt.time_slot_start = Iceutility.ConvertToUTC(startDateandTime, true);
            this.newAppt.time_slot_end = Iceutility.ConvertToUTC(Iceutility.addTime(Iceutility.GetLocalDate(this.newAppt.time_slot_start), 0, 0, 30, 0), true);

            // appointment_type
            let foundType = ScheduleService.getAppointmentTypes().filter(t => t.value == this.typeCtrl.getFormControl().value);
            if (foundType.length > 0) {
              this.newAppt.appointment_type = foundType[0].value;
            }

            // status
            let foundStatus = ScheduleService.getApptStatuses().filter(s => s.value == this.statusCtrl.getFormControl().value);
            if (foundStatus.length > 0) {
              this.newAppt.appointment_status = foundStatus[0].value;
            }

            // To do fix up Subscribers, Patients and Members
            this.schSvc.insertUpdateAppointment(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), "", this.newAppt).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                if (this.newAppt == null) return;

                if (this.dataSource.data == null) this.dataSource.data = [];

                let svrDoc: appointment = <appointment>data[0];
                if (svrDoc == null) return;

                let iconToUse = "fas fa-walking";
                if (Iceutility.toBoolean(svrDoc["telehealth"])) {
                  iconToUse = "fas fa-video";
                }

                if (this.schSvc.appointmentInSession(svrDoc["time_slot_start"], svrDoc["time_slot_end"], svrDoc["appointment_status"]))
                  iconToUse += " " + "alert-success";
                else
                  iconToUse = "";

                let startDateTime = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(svrDoc["time_slot_start"]));

                // To do fix to include the SUBITEM_TYPE
                let dApt = {
                  start_time: startDateTime.split(" ")[1],
                  appointment_status: ScheduleService.getApptStat(svrDoc["appointment_status"]),
                  appointment_type: ScheduleService.getAppointmentType(svrDoc["appointment_type"]),
                  providers: svrDoc["providers"],
                  appointment_key: svrDoc["appointment_key"],
                  account_type: svrDoc["account_type"],
                  trans_account: svrDoc["trans_account"],
                  time_slot_start: startDateTime,
                  time_slot_end: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(svrDoc["time_slot_end"])),
                  subject: svrDoc["subject"],
                  telehealth: svrDoc["telehealth"],
                  telehealth_class: iconToUse,
                };

                if (this.newAppt.offline_record_status == IceTypes.offlineRecStatus.offlineInsert || this.dataSource.data.length == 0) {
                  this.dataSource.data.push(dApt);
                }
                else {
                  let foundApt = this.dataSource.data.filter(a => a["appointment_key"] == dApt.appointment_key)
                  if (foundApt.length > 0)
                    foundApt[0] = dApt;
                }

                this.dataSource.data = this.dataSource.data;
                this.newAppt = null;
              },
              error => {
                this.newAppt = null;

                // To do, log error
              });
          }
          break;
        }
      }
    }
  }

  onControlChange(event) {
    if (event.singleUploadSettings != null) {
      switch (event.singleUploadSettings.id) {
        case "file": {
          break;
        }
      }
    }
  }

  onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        default: {
          this.getAppService().showEditPanelSection(this.getEditingSectionTag());
          this.newAppt = null; // reset
          this.newAppt = new appointment();
          this.newAppt.appointment_key = Iceutility.guid(true);
          let dt = Iceutility.GetLocalDate();
          this.newAppt.time_slot_start = dt;
          this.newAppt.time_slot_end = dt;

          this.newAppt.appointment_type = IceTypes.appt_type.appttypeInitial;
          this.newAppt.interval_type = IceTypes.interval.interval15;
          this.newAppt.offline_record_status = IceTypes.offlineRecStatus.offlineInsert;
          this.newAppt.slot_color = "#1400F7";
          this.newAppt.slot_font_color = "#F4EBEC";
          this.newAppt.subject = "New Meeting";

          this.getAppService().editPanelSectionUpdate(this.getEditingSectionTag(), false, this.newAppt);
          break;
        }
      }
    }
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    if (event.actionItem == null) return;

    if (IceTypes.recordQuickActionEdit.value == event.actionItem.value) {
      let doc = <appointmentindex>event["rowData"];
      if (doc == null) {
        // To do log error
        return;
      }

      this.schSvc.getAppointment(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), doc.appointment_key).subscribe(
        data => {
          if (data == null || data.length == 0) return;

          this.getAppService().showEditPanelSection(this.getEditingSectionTag());
          this.newAppt = <appointment>data[0]; // reset
          this.newAppt.time_slot_start = Iceutility.ConvertFromDotNetServerTime(this.newAppt.time_slot_start);
          this.newAppt.time_slot_end = Iceutility.ConvertFromDotNetServerTime(this.newAppt.time_slot_end);

          let foundType = this.typeCtrl.getOptions().filter(t => t.value == Iceutility.toLong(this.newAppt.appointment_type));
          if (foundType.length > 0) {
            this.typeCtrl.getFormControl().setValue(Iceutility.toLong(foundType[0].value));
            this.newAppt.appointment_type = foundType[0].name;
          }
          else {
            this.typeCtrl.getOptions().push({ name: "None", value: 0 });
            this.typeCtrl.getFormControl().setValue(Iceutility.toLong(this.newAppt.appointment_type));
          }

          let foundStatus = this.statusCtrl.getOptions().filter(t => t.value == Iceutility.toLong(this.newAppt.appointment_status));
          if (foundStatus.length > 0) {
            this.statusCtrl.getFormControl().setValue(Iceutility.toLong(foundStatus[0].value));
            this.newAppt.appointment_status = foundStatus[0].name;
          }

          let startdt_time = Iceutility.getDateTextEx(this.newAppt.time_slot_start);
          let parts = startdt_time.split(" ");
          if (parts.length > 2) {
            this.newAppt["start_time"] = parts[1] + " " + parts[2];
            let opts = this.startTimeCtrl.getOptions();
            if (opts.filter(t => t.name == this.newAppt["start_time"]).length == 0)
              opts.push({ name: this.newAppt["start_time"], value: this.newAppt["start_time"]});
          }

          this.getAppService().editPanelSectionUpdate(this.getEditingSectionTag(), false, this.newAppt);
        },
        error => {
          // To do log error
        });
    }
    else if (IceTypes.recordQuickActionRemove.value == event.actionItem.value) {
      let doc = <appointmentindex>event["rowData"];
      if (doc == null) {
        // To do log error
        return;
      }
      this.schSvc.deleteAppointment(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), doc.appointment_key).subscribe(
        data => {
          if (this.dataSource.data != null && this.dataSource.data.length > 0) {
            this.dataSource.data = this.dataSource.data.filter(d => d.appointment_key != doc.appointment_key);
          }
        },
        error => {
          // To do, log error
        });
    }
    else if (IceTypes.recordQuickActionView.value == event.actionItem.value) {
    //  let doc = <externaldata>event["rowData"];
    //  if (doc == null) {
    //    // To do log error
    //    return;
    //  }
    //  this.payerService.downloadDocument("payers", this.getAppService().getCurrentAccount(), event.rowData.external_data_key, event.rowData.parent_src_type);
    }
    else if (IceTypes.recordQuickActionJoinMeeting.value == event.actionItem.value) {
    //  if (event.colDef == null) return;
    //  if (Iceutility.isdefined(event.rowData["appointment_key"]) == false) return;
    //  if (Iceutility.isdefined(event.rowData["telehealth"]) == false) return;
    //  let apptkey = event.rowData["appointment_key"];
    //  let telehealth = event.rowData["telehealth"];
    //  if (Iceutility.toBoolean(telehealth)) {
    //    this.schSvc.getAppointment(event.rowData.trans_account, event.rowData.account_type, apptkey).subscribe(
    //      data => {
    //        if (data == null || data.length == 0) return;
    //        let appt: appointment = <appointment>data[0];
    //        if (this.schSvc.appointmentInSession(appt.time_slot_start, appt.time_slot_end, appt.appointment_status))
    //          this.schSvc.navigateToTelehealth(appt.telehealth_url);
    //      },
    //      error => {
    //      });
    //  }
    }
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      this.messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "An error occurred while downloading the document.");
      return;
    }
  }
}
